import { render } from "./ActionsBlock.vue?vue&type=template&id=450f8e2a&scoped=true"
import script from "./ActionsBlock.vue?vue&type=script&lang=js"
export * from "./ActionsBlock.vue?vue&type=script&lang=js"

import "./ActionsBlock.vue?vue&type=style&index=0&id=450f8e2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-450f8e2a"]])

export default __exports__